module.exports = __webpack_public_path__ + "img/omelette-off.adb74166.svg";